import { useEffect, useState, forwardRef } from "react";
import {
    Typography, TextField, Button, Grid, Box, Dialog, DialogActions,
    DialogContent, DialogContentText, DialogTitle, Slide, Tooltip
} from "@mui/material";
import { __fetching_data__ } from "../../../components/api.js";
import { useSelector } from "react-redux";
import FileCopyIcon from '@mui/icons-material/FileCopy';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const TabAPI = ({ userDetail, colors, onTabDataChange }) => {
    const csrfToken = useSelector((state) => state.csrfToken);
    const [localUserDetail, setLocalUserDetail] = useState(userDetail);
    const [reqAppId, setReqAppId] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(null); // "first" | "second" | null
    const [isTooltipOpenAppId, setIsTooltipOpenAppId] = useState(false);
    const [isTooltipOpenAppSecret, setIsTooltipOpenAppSecret] = useState(false);

    const base_api_url =
        process.env.NODE_ENV === "production"
            ? window.location.protocol === "https:" ? process.env.REACT_APP_API_HTTPS_URL : process.env.REACT_APP_API_HTTP_URL
            : "/application";

    useEffect(() => {
        if (localUserDetail.app_id && localUserDetail.app_secret) setReqAppId(true);
    }, []);

    const handleGenerateAppId = async () => {
        const response = await __fetching_data__({
            url: `${base_api_url}/genapikey`,
            method: "POST",
            headers: { "xsrf-token": csrfToken },
        });
        if (response.status) {
            const { app_id, app_secret } = response.data;
            setLocalUserDetail((prev) => ({ ...prev, app_id, app_secret }));
            onTabDataChange({ app_id, app_secret });
            setReqAppId(true);
        }
        setDialogOpen(null);
    };

    const handleCopyClick = (event, tooltipSetter) => {
        event.target.select();
        document.execCommand("copy");
        tooltipSetter(true);
        setTimeout(() => tooltipSetter(false), 1500);
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                {!reqAppId ? (
                    <Box>
                        <Box display="flex" alignItems="center" gap="1rem">
                            <Typography>{"Application ID : "}</Typography>
                            <Typography>{localUserDetail?.app_id}</Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap="1rem">
                            <Button
                                variant="contained"
                                onClick={() => setDialogOpen("first")}
                                sx={{ backgroundColor: colors.blueAccent[400] }}
                            >
                                สร้าง Application ID
                            </Button>
                        </Box>
                    </Box>
                ) : (
                    <Box>
                        <Box mb="2rem">
                            <Typography color="textSecondary">{"Application ID : "}</Typography>
                            <Tooltip open={isTooltipOpenAppId} title="Copied!" placement="top" arrow>
                                <TextField
                                    value={localUserDetail?.app_id}
                                    onClick={(e) => handleCopyClick(e, setIsTooltipOpenAppId)}
                                    InputProps={{ readOnly: true }}
                                    variant="outlined"
                                    size="small"
                                    sx={{ width: "50%" }}
                                />
                            </Tooltip>
                        </Box>
                        <Box>
                            <Typography color="textSecondary">{"Application Secret : "}</Typography>
                            <Tooltip open={isTooltipOpenAppSecret} title="Copied!" placement="top" arrow>
                                <TextField
                                    value={localUserDetail?.app_secret}
                                    onClick={(e) => handleCopyClick(e, setIsTooltipOpenAppSecret)}
                                    InputProps={{ readOnly: true }}
                                    variant="outlined"
                                    size="small"
                                    sx={{ width: "50%" }}
                                />
                            </Tooltip>
                        </Box>
                        <Box mt={2}>
                            <Typography color="error">
                                * Application Secret นี้จะแสดงให้เห็นเพียงครั้งเดียว กรุณาบันทึกไว้ในที่ปลอดภัย ก่อนเปลี่ยนหน้า หรือรีเฟรช
                            </Typography>
                        </Box>
                        <Box mt={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => setDialogOpen("second")}
                            >
                                สร้าง Application ID ใหม่
                            </Button>
                        </Box>
                    </Box>
                )}
            </Grid>

            {/* Dialog ทั้งสองรวมกัน */}
            <Dialog
                open={Boolean(dialogOpen)}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setDialogOpen(null)}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>
                    {dialogOpen === "first"
                        ? "ต้องการที่จะสร้าง Application ID ใหม่ หรือไม่?"
                        : "คุณแน่ใจหรือไม่ว่าต้องการสร้าง Application ID ใหม่? การดำเนินการนี้จะ ลบ Application ID เดิมและ Secret ที่มีอยู่ ซึ่งจะ ไม่สามารถกู้คืนได้"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" />
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={() => setDialogOpen(null)}>
                        ยกเลิก
                    </Button>
                    <Button variant="contained" color="secondary" onClick={handleGenerateAppId}>
                        ตกลง
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
};

export default TabAPI;
